<form [formGroup]="rzFg">
    <snelstart-ui-text-form-control formControlName="omschrijving"
                                    id="omschrijving"
                                    label="Omschrijving"
                                    class="me-1 custom-input-250"
                                    (change)="saveForm()"
    >
    </snelstart-ui-text-form-control>
    <snelstart-ui-number-form-control formControlName="bedrag"
                                      id="bedrag"
                                      label="Bedrag"
                                      [showAllDecimals]="false"
                                      align="right"
                                      [minValue]="1"
                                      prefix="€"
                                      class="me-1 custom-input-250"
                                      (change)="saveForm()"
    >
    </snelstart-ui-number-form-control>
    <snelstart-ui-select-form-control formControlName="soortRoerendeZaak"
                                      id="soortRoerendeZaak"
                                      label="Soort zaak"
                                      class="me-1 custom-input-250"
                                      [required]=true
                                      [options]="this.optionsRoerendeZaken"
                                      (change)="saveForm()"
    >
    </snelstart-ui-select-form-control>
</form>
